// analytics/claritySteps.ts
export type ReservationStep = | "search" | "addServices" | "customerInfo" | "resSummary"
    | "paymentProvider" | "payment" | "resultSuccess" | "resultFailed" | "resultSuccessQuotaFree" | "resCancelled";

export function claritySet(key: string, value: string | number | boolean) {
    (window as any).clarity("set", key, value);
}

export function clarityEvent(name: string, data?: Record<string, any>) {
    (window as any).clarity("event", name, data);
}

/** Safe versions that silently no-op when Clarity is not loaded yet */
export function claritySetSafe(key: string, value: string | number | boolean) {
    if (typeof (window as any).clarity === 'function') {
        (window as any).clarity("set", key, value);
    }
}

export function clarityEventSafe(name: string) {
    if (typeof (window as any).clarity === 'function') {
        (window as any).clarity("event", name);
    }
}

export function trackStep(step: ReservationStep) {
    claritySet("reservation_step", step); // filterable tag
    clarityEvent(`reservation_step_${step}`); // funnel-friendly event
}